<template>
  <div class="km__modules__productsize km__popup middle">
    <button class="km__button--close" type="button" name="close" @click="$emit('close')" aria-label="close"></button>
    <h2 class="km__popup--heading">{{ $t("konf_sizesTable") }}</h2>
    <div class="km__popup--content" v-html="htmlstring">
    </div>
    <div class="km__popup--buttons">
      <button class="km__button--standard" @click="$emit('close')">{{ $t("konf_OK") }}</button>
    </div>
  </div>
</template>

<script lang="ts" setup>
// import {nextTick, onMounted, PropType, Ref, ref, watch} from "vue";
// import {initMasseinheitenSwitcher} from "@km/js/masseinheitenSwitcher";

const props = defineProps({
  htmlstring: String
})


// onMounted(() => {
//   nextTick(() => initMasseinheitenSwitcher());
// })


</script>
<style lang="scss">
.km__modules__productsize.middle {
  overflow-y: scroll;

  .km__popup--heading {
    z-index: 9999;
  }

  .km__button--close {
    position: fixed;
    z-index: 99999;
  }

  .km__popup--buttons {
    justify-content: center;
  }

  .km__popup--content {
    background: $color-white;
  }
}

#product-size {
  padding-top: 40px;
  position: relative;

  h2 {
    margin-bottom: 20px;
  }

  .size-owayo {
    position: relative;
    margin-bottom: 40px;

    h3 {
      display: flex;
      margin-bottom: 40px;

      @media (max-width: 620px) {
        margin-bottom: 80px;
      }

      span {
        text-transform: none;
        font-weight: 600;
        padding-top: 15px;
        padding-left: 10px;
      }
    }
  }

  table {
    border-collapse: collapse;
  }

  th, td {
    border: 1px solid black;
    padding: 1em;
    font-size: 12px;
    text-align: center;

    &:first-child {
      text-align: left;
    }

  }

  thead th {
    background: $color-blue;
    color: $color-white;
  }

  .wrapper-masseinheiten {
    position: absolute;
    right: 80px;
    top: 12px;
    -webkit-border-radius: 20px;
    border-radius: 20px;
    background-clip: padding-box;
    background: #333;
    text-align: left;
    width: 63px;
    height: 26px;
    border: 3px solid #333;

    @media (max-width: 620px) {
      top: 80px;
    }
  }

  .wrapper-masseinheiten .masseinheiten_switcher {
    display: inline-block;
    color: #333;
    padding: 5px;
    cursor: pointer;
    -webkit-border-radius: 20px;
    border-radius: 20px;
    background-clip: padding-box;
    width: 20px;
    height: 20px;
    text-align: center;
    position: absolute;
    top: 0;

    &.masseinheit_button_inches {
      left: 0;

      span {
        left: -70px;
        position: absolute;
        color: #333;
        display: block;
        z-index: 99;
        font-size: 16px;
        font-weight: 600;
        top: -1px;
      }
    }

    &.masseinheit_button_cm {
      right: 0;

      span {
        position: absolute;
        color: #333;
        display: block;
        z-index: 99;
        font-size: 16px;
        font-weight: 600;
        top: -1px;
        right: -40px;
      }
    }

    &.active {
      background-color: #fff;
      color: #000;
    }
  }

  .groessenLinkAufPDF {
    float: none;
    clear: both;
  }

  .richtig-messen {
    .row {
      display: flex;

      @media (max-width: 620px) {
        flex-direction: column;
      }

      .col-33 {
        width: 30%;

        @media (max-width: 620px) {
          width: 100%;
        }

        &:nth-child(1) {
          padding-top: 10%;
          text-align: center;
        }

        &:nth-child(2) {
          width: 40%;
          padding-left: 40px;
          padding-right: 40px;

          @media (max-width: 620px) {
            width: 50%;
            margin: 0 auto 30px auto;
          }
        }
      }
    }
  }

  .block-question {
    width: 50%;
    display: block;
    background: #ccc;
    text-align: center;
    padding: 20px;
    font-weight: 600;
    margin: 60px auto 80px auto;

    p {
      margin-bottom: 0;
    }
  }
}

</style>
